import React from 'react'
import { Link } from 'react-router-dom'
import './AboutSession.css'

function AboutSession() {

  return (
    <div className="about-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 about-text-col">
            <h2 className="about-heading">INTERNATIONAL FREIGHT FORWARDERS</h2>
            <p className="about-tagline">
              Centrex marine services is dedicated to providing reliable and modern international freight & logistics solutions from Pakistan and the world over since the last 2 decades.
            </p>
            <p className="about-description">
              With over two decades of experience in handling cargoes both in imports and from Pakistan to global markets. We provide affordable <Link to="/services/sea-freight" className="service-link">Sea Freight</Link> and Road Freight services which are professionally managed by our team. Centrex marine services is an international freight forwarders company handling cargoes management to tracking and handling. From perishable cargo or bulk load Centrex marine services is the trustworthy choice for all your logistic needs. Our primary concern is to provide smooth and timely Sea Freight and <Link to="/services/road-freight" className="service-link">Road Freight</Link> services at an affordable price.
            </p>
            <div className="about-btn-container ">
              <Link to="/about" className="about-btn">Read More</Link>
            </div>
          </div>
          <div className="col-lg-5 about-image-col">
            <img src="/Pics/Aboutimage.jpg" alt="Centrex marine services Services" className="about-image" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutSession
